const ALIAS = {
  DOMAIN: 'alias',
};

export default ALIAS;
